import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Settings, Shield, Users } from 'lucide-react';
import { useAdminCheck } from '@/hooks/useAdminCheck';
import { useLanguage } from '@/contexts/LanguageContext';

export const AdminAccessButton = () => {
  const { isAdmin, checking } = useAdminCheck();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();

  // Don't show anything if not admin or still checking
  if (checking || !isAdmin) return null;

  const isOnAdminDashboard = location.pathname === '/admin-dashboard';

  const handleToggleDashboard = () => {
    if (isOnAdminDashboard) {
      navigate('/');
    } else {
      navigate('/admin-dashboard');
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50">
      <Button
        variant="outline"
        onClick={handleToggleDashboard}
        className="bg-card/95 dark:bg-card/95 backdrop-blur-sm border-primary/20 shadow-lg hover:bg-primary/5 transition-all duration-200"
      >
        {isOnAdminDashboard ? (
          <>
            <Users className="h-4 w-4 text-primary mr-2" />
            <Badge variant="secondary" className="bg-primary/10 text-primary border-primary/20">
              {t('client')}
            </Badge>
          </>
        ) : (
          <>
            <Shield className="h-4 w-4 text-primary mr-2" />
            <Badge variant="secondary" className="bg-primary/10 text-primary border-primary/20">
              {t('admin')}
            </Badge>
          </>
        )}
      </Button>
    </div>
  );
};